<script lang="ts" >
    import { onMount } from "svelte";
    import { appstates } from "../../stores/app-state";
    import { RequirementStore } from "../../stores/requirement-store";
    // import Navigation from "../common/navigation.component.svelte";
    import Step from "../common/step.component.svelte";
    import InputBox from "../ui/InputBox.svelte";

    // Export
    export let title: string = "";

    // Vars
    let projectName : string = "";
    let description : string = "";

    // Calc : can we go to next
    $: nextEnable = (projectName.trim().length > 5) && (description.trim().length > 5);

    // Functions
    // -- onMount
     onMount(() => {
       const info = RequirementStore.getInfos();
       projectName = info.title;
       description = info.description;
    });

    const handleNext = () => {
        // Check
        if(nextEnable) {
            RequirementStore.updateInfos(projectName, description);
            appstates.next();
        }
    }

</script>


<Step 
    title={ title }
    nextEnable={nextEnable}
    imageIndex= { $appstates }
    on:navigation-next={handleNext}
    >
    <svelte:fragment slot="presentation">
        Bienvenue sur cette petite application dont l'objectif est de vous aider à formaliser en quelques mots votre projet avant d'échanger avec un partenaire pour réalisation. 
        Les prochains écrans vont vous demander de renseigners plus informations afin d'organiser les choses et aider aux premières étapes de cadrage.
    </svelte:fragment>
   
    <svelte:fragment slot="content"> 
        <div class="content">
            <p style="text-align:center">
                Commençons par donner un titre et petite description à votre projet.
            </p>
            <h3> Titre (*) </h3>
            <InputBox>
                <input
                    type="text"
                    bind:value={projectName}
                    placeholder="Donnons un nom à votre projet"
                />
            </InputBox>
            <small class="help"> Obligatoire - Au moins 5 caractères </small>
            <h3> Description (*) </h3>
            <InputBox>
                <textarea bind:value={description} id="description" ></textarea>
            </InputBox>
            <small class="help"> Obligatoire - Au moins 5 caractères </small>
        </div>
    </svelte:fragment>
</Step>

<style>
    .content {
        padding: 50px;
    }


    

    h3 {
        margin-top:20px;
    }

</style>


   


